import { Action, ActionType } from "@redux/actionTypes/otherMaterialsActionType";
import { Reducer } from "redux";

export interface IOtherMaterialState {
  otherMaterialByPID: IOMaterialDetailsByPID[];
}

export interface IOMaterialDetailsByPID {
  projectId: number;
  projectName: string;
  otherMaterialData: IOtherMaterialData;
  calculations?: ICalculation;
  isSubmitEnable?: boolean;
  isDraft?: boolean;
}
export interface Iheaders {
  headName: string;
  value: string;
  classname?: string;
  separator?: string;
}
export interface ICalculation {
  headers: Iheaders[];
  tableData: Record<string, any>[];
}
export interface IOtherMaterialData {
  headers: Iheaders[];
  tableData: Record<string, any>[];
}

const initialState = {
  otherMaterialByPID: [],
};

export const otherMaterialReducer: Reducer<IOtherMaterialState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.OTHER_MATERIALS_DETAILS_BY_PID:
      return {
        ...state,
        otherMaterialByPID: action.payload,
      };
    default:
      return state;
  }
};
